// extracted by css-extract-rspack-plugin
export default {"iconLabel":"iconLabel-rVFaJ0","warningGlyph":"warningGlyph-LsPTI7","icon":"icon-uV7t8A","link":"link-G_HJxB"};